import React, { useContext } from 'react';
import { Modal, Table, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown'
import { Editor } from '@tinymce/tinymce-react';
import { ViewOnly } from '../TinyEditorConfig';
import UserContext from '../../contexts/UserContext';

const CalendarModal = (props) => {

    const userContext = useContext(UserContext)
    return (
        <Modal
            open={props.modal}
            onClose={() => props.toggleModal()}
        >
            <Modal.Header>{props.event.title}</Modal.Header>
            <Modal.Content>
                <Table definition attached>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>Start Date:</Table.Cell>
                            <Table.Cell>{props.event._instance.range.start.toString()}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>End Date:</Table.Cell>
                            <Table.Cell>{props.event._instance.range.end.toString()}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Reason:</Table.Cell>
                            <Table.Cell><ReactMarkdown children={props.event.extendedProps.reason}/></Table.Cell>
                        </Table.Row>
                        {props.event.extendedProps.impact===undefined?null:
                        <Table.Row>
                            <Table.Cell>Impact:</Table.Cell>
                            <Table.Cell>{props.event.extendedProps.impact}</Table.Cell>
                        </Table.Row>}
                        <Table.Row>
                            <Table.Cell>Sites: </Table.Cell>
                            <Table.Cell>{userContext.userInfo.site_list.filter(s =>props.event.extendedProps.sites.includes(s.site)).map(i => <div key={i.label}>{i.label}</div>)}</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                    </Table>
                    {props.event.extendedProps.notes===undefined ?null:
                        <Table celled padded attached='bottom'>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Notes</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell><Editor init={ViewOnly} value={props.event.extendedProps.notes} /></Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    }
                    <Modal.Actions>
                    {localStorage.getItem('admin-storage') && localStorage.getItem('admin-storage') !== "false"?
                    <Link to={`/tickets/details/${props.event.extendedProps.number}`}>
                        <Button>Go to Ticket</Button>
                    </Link>
                    :
                        <Link to={`/tickets/details/${props.event.extendedProps.number}`}>
                            <Button>Go to Ticket</Button>
                        </Link>}
                    </Modal.Actions>
            </Modal.Content>
        </Modal>
    )

}

export default CalendarModal